import React from 'react'
import type {
  InlineInputContentOptions,
  InlineInputDisplayContent,
  InlineInputEditContent,
  InlineInputProps,
} from '@ztechapps/webui.input'
import { InlineInput } from '@ztechapps/webui.input'
import { HoverEditCodeLinks } from '@ztechapps/webui.data-tools'
import { WorkOrderCodeLink } from '../WorkOrderCodeLink/WorkOrderCodeLink'
import { WorkOrderSelect } from '../WorkOrderSelect'

const DisplayContent: InlineInputDisplayContent = (
  initialValues: any,
  onClick: any,
  { canEdit }: InlineInputContentOptions
) => {
  return <HoverEditCodeLinks onClick={onClick} canEdit={canEdit} values={initialValues} CodeLink={WorkOrderCodeLink} />
}

const EditContent: InlineInputEditContent = ({
  value,
  setNewValue,
  documentId,
  ...props
}: InlineInputContentOptions) => {
  return (
    <WorkOrderSelect
      {...props}
      filter={{ _id: { $ne: documentId } }}
      onChange={(e) => setNewValue(e)}
      value={value}
      isMulti={true}
      autoFocus
    />
  )
}

export const RelatedWorkOrderInlineInput = ({
  parentInputComponent,
  initialValues,
  displayContent,
  editContent,
  name = 'relatedWorkOrders',
  label = 'Productions',
  help = 'The related productions for this item.',
  ...props
}: InlineInputProps) => {
  const ParentInput = parentInputComponent || InlineInput

  const mappedInitialValues = {
    ...initialValues,
    [name]: initialValues?.[name]?.map((item) => {
      return {
        ...item,
        value: item?._id,
        label: item.code, //we need this to work with dropdown
      }
    }),
  }

  return (
    <ParentInput
      label={label}
      help={help}
      name={name}
      initialValues={mappedInitialValues}
      displayContent={displayContent ?? DisplayContent}
      editContent={editContent ?? EditContent}
      horizontalLayout
      {...props}
    />
  )
}
